import React from 'react';

import classNames from 'classnames';
import './nackle-tile.less';
import { NackleErrorBoundary } from '..';

/**
 * A tile component with double wide and infinity tall styling that wraps content in an error boundary.
 * 
 * @param {Object} props - The component props
 * @param {string} [props.className] - Additional CSS class name to apply to the tile
 * @param {boolean} [props.containerOnly] - Whether to apply container-only styling
 * @param {string} [props.resultSize] - Size of the result, defaults to 'small' if not provided
 * @param {Function} [props.onError] - Error handler function passed to the error boundary
 * @param {React.ReactNode} props.children - Child components to render within the tile
 * @returns {React.ReactElement} The rendered tile component
 */
const NackleTileDoubleInfinity = ( { className, containerOnly, resultSize, onError, children } ) => {
    const tileClasses = classNames( {
        'nackle-tile': true,
        'nackle-tile-double-infinity': true,
        'container-only': containerOnly ? true : false,
        [ className ]: className ? true : false
    } );
    return (
        <div className={ tileClasses }>
            <NackleErrorBoundary onError={ onError } resultSize={ resultSize || 'small' }>
                { children }
            </NackleErrorBoundary>
        </div>
    );
};

export { NackleTileDoubleInfinity };